import { render } from "./editcustomergroup.vue?vue&type=template&id=741f421e"
import script from "./editcustomergroup.vue?vue&type=script&lang=js"
export * from "./editcustomergroup.vue?vue&type=script&lang=js"

import exportComponent from "/Users/arthaskyline/Documents/FILE_DELFIN/kodingan-arthaskyline/level-up/levelup-github/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__